<template>
	<section class="page-content-slim">
		<div class="container">
			<div class="col-xs-12 col-sm-8">
				<h1>{{ page.title }}</h1>
			</div>
			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-9">
				<p v-html="page.content"/>
			</div>
		</div>
	</section>
</template>

<style lang="less" scoped>
	.container {
		min-height: 650px;
	}
</style>


<script>
export default {
	created() {
		this.getPage();
	},
	data() {
		return {
			page: {
				title: null,
				content: null
			}
		};
	},
	methods: {
		async getPage() {
			const { id } = this.$route.params;
			const { data: { data: page } } = await this.$axios.get(`/page/${id}`);
			this.$set(this, 'page', page);
		}
	},
	watch: {
		'$route.params.id': async function pageIdWatcher() {
			this.getPage();
		}
	}
};
</script>
